export const getNodes = (target) => [target].flat().map(node).filter(Boolean);
const node = (target) => target instanceof Node ? target : target === null || target === void 0 ? void 0 : target.current;
export const noop = () => void 0;
//# sourceMappingURL=shared.js.map